/*
 * GT Catalog Toolbar
 * ------------------
 * Powers the count/sort/view toolbar on the redesigned category pages
 * (packaging / paper / cleaning / medical). Document-level delegation so it
 * survives any re-render and never binds per-element listeners. Guarded
 * against double inclusion.
 *
 *  - [data-gt-sort]  : real Shopify sort. Updates ?sort_by= and reloads,
 *                      preserving every other query param and resetting page.
 *  - [data-gt-view]  : Grid/List toggle. Pure CSS class switch on the grid,
 *                      no reload, no layout shift beyond the intended change.
 */
(function () {
  if (window.__gtCatalogToolbarInit) return;
  window.__gtCatalogToolbarInit = true;

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-gt-sort]');
    if (!select) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-gt-view]');
    if (!btn) return;

    var toolbar = btn.closest('.gt-toolbar');
    var main = btn.closest('.gt-catalog__main') || document;
    var grid = main.querySelector('#product-grid, .gt-catalog__grid');
    if (!grid) return;

    var mode = btn.getAttribute('data-gt-view');
    grid.classList.toggle('gt-catalog__grid--list', mode === 'list');

    if (toolbar) {
      toolbar.querySelectorAll('[data-gt-view]').forEach(function (b) {
        var active = b === btn;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }
  });
})();
